// export const BaseUrl = 'http://localhost:3001/api';
// export const SocketUrl = 'http://localhost:3001';
// export const ShareBaseUrl = 'https://www.wafynet.com';

export const BaseUrl = 'https://qa.wafynet.com/api';
export const SocketUrl = 'https://qa.wafynet.com';
export const ShareBaseUrl = 'https://qa.wafynet.com';

// export const BaseUrl = 'https://www.wafynet.com/api';
// export const SocketUrl = 'https://www.wafynet.com';
// export const ShareBaseUrl = 'https://www.wafynet.com';

export const localIP = '2.50.64.12';

// Google Login
export const GoogleAuthClientId = '993491890829-nh407d38ntbb5p46icn8rf95av1b9fdo.apps.googleusercontent.com';
export const IOSAuthClientId = '993491890829-cjj64kpkc2bgjaad1uquaq004ok300k7.apps.googleusercontent.com';
// Debug
// export const AndroidAuthClientId = '993491890829-v9jn0055vaahdfauj0j52id2bt720j63.apps.googleusercontent.com';
// Release
export const AndroidAuthClientId = '993491890829-ra74948uopklsjtu9g4eqkn9nf3l7362.apps.googleusercontent.com';

// Apple Login
export const IOSAppleClientId = 'com.wafynet.login';
export const WebAppleClientId = 'com.wafynet.weblogin';
export const AppleRedirectURI = `${ShareBaseUrl}/apple-auth`;
